import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route, Outlet, useLocation, Navigate } from "react-router-dom";
import { ReactLenis, useLenis } from "lenis/react";
import "@/App.css";
import { Toaster } from "sonner";
import { ScrollProgress, CustomCursor } from "@/components/site/Chrome";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { FloatingWhatsApp } from "@/components/site/FloatingWhatsApp";
import { MobileCTABar } from "@/components/site/MobileCTABar";
import { CookieConsent } from "@/components/site/CookieConsent";
import { ChatWidget } from "@/components/site/ChatWidget";
import Home from "@/pages/Home";
import CourseDetail from "@/pages/CourseDetail";
import Privacy from "@/pages/Privacy";
import Corsi from "@/pages/Corsi";
import ChiSiamo from "@/pages/ChiSiamo";
import AziendePage from "@/pages/AziendePage";
import Contatti from "@/pages/Contatti";
import Coworking from "@/pages/Coworking";
import Domiciliazione from "@/pages/Domiciliazione";
import FgasPage from "@/pages/FgasPage";
import { BookingProvider } from "@/components/site/BookingContext";

const ScrollManager = () => {
  const { pathname, hash } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 350);
        return;
      }
    }
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, hash, lenis]);
  return null;
};

const Layout = () => (
  <div className="App relative">
    <div className="grain-overlay" />
    <ScrollProgress />
    <CustomCursor />
    <Toaster position="top-center" richColors />
    <ScrollManager />
    <Header />
    <main>
      <Outlet />
    </main>
    <Footer />
    <div className="h-16 md:hidden" />
    <FloatingWhatsApp />
    <MobileCTABar />
    <ChatWidget />
    <CookieConsent />
  </div>
);

function App() {
  return (
    <HelmetProvider>
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <BrowserRouter>
        <BookingProvider>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Home />} />
            <Route path="/corsi" element={<Corsi />} />
            <Route path="/corsi/:id" element={<CourseDetail />} />
            <Route path="/chi-siamo" element={<ChiSiamo />} />
            <Route path="/aziende" element={<AziendePage />} />
            <Route path="/coworking" element={<Coworking />} />
            <Route path="/domiciliazione" element={<Domiciliazione />} />
            <Route path="/fgas" element={<FgasPage />} />
            <Route path="/blog" element={<Navigate to="/coworking" replace />} />
            <Route path="/blog/:slug" element={<Navigate to="/coworking" replace />} />
            <Route path="/contatti" element={<Contatti />} />
            <Route path="/privacy" element={<Privacy />} />
          </Route>
        </Routes>
        </BookingProvider>
      </BrowserRouter>
    </ReactLenis>
    </HelmetProvider>
  );
}

export default App;
